import CloseButton from './CloseButton'
import Modal from './Modal'
import ModalFlex from './ModalFlex'
import ModalHeader from './ModalHeader'
import ModalHeaderLabel from './ModalHeaderLabel'

export default Modal
export { CloseButton, ModalHeader, ModalFlex, ModalHeaderLabel }
